"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInteractionSelectionParameterSettings = void 0;
// #endregion Interfaces (1)
// #region Functions (1)
function isInteractionSelectionParameterSettings(def) {
    return (def === null || def === void 0 ? void 0 : def.type) === 'selection';
}
exports.isInteractionSelectionParameterSettings = isInteractionSelectionParameterSettings;
// #endregion Functions (1)
//# sourceMappingURL=ISelectionParameterSettings.js.map